import React from 'react';
import cx from 'classnames';
import { Reveal } from 'react-reveal';

import { GreenButton, WhiteButton } from '@marketing/components/buttons';

import ConcentricCircles from '../../assets/concentric_circles.svg';

import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

interface Props {
  admissionsBundleOfferRegistrationUrl: string;
  premiumOfferRegistrationUrl: string;
  trialOfferRegistrationUrl: string;
}

export default (props: Props) => {
  return (
    <div className="align-items-center d-flex" style={{ minHeight: 400, position: 'relative' }}>
      <div
        style={{
          bottom: 0,
          left: '50%',
          position: 'absolute',
          top: 0,
          transform: 'scaleY(-1) translateX(-50%)',
          width: 1130,
          zIndex: -2
        }}
      >
        <img alt="" loading="lazy" src={ConcentricCircles} />
      </div>

      <div className={cx(styles.startYourPrepContainer, 'd-flex flex-1 flex-column gap-m')}>
        <Reveal duration={1000} effect={marketingStyles.fadeInAndSlideUp}>
          <h3 className="text-center u-margin-A-n" style={{ fontSize: 40 }}>
            <strong>Start your GRE prep today!</strong>
          </h3>

          <div className="text-center" style={{ fontSize: 18 }}>
            Zero risk: 7-day “No questions asked” money-back guarantee
            <br /> +5 points improvement on your previous GRE test. Guaranteed!
          </div>
        </Reveal>

        <div className="d-flex flex-column flex-lg-row gap-m justify-content-center">
          <WhiteButton href={props.premiumOfferRegistrationUrl}>
            Sign up for GRE Only
          </WhiteButton>
          <GreenButton href={props.admissionsBundleOfferRegistrationUrl}>
            Sign up for GRE + Admissions
          </GreenButton>
        </div>

        <div className="text-center">
          <a className="small text-gray-light" href={props.trialOfferRegistrationUrl}>
            Try Magoosh GRE for 7 days with no commitment
          </a>
        </div>
      </div>
    </div>
  );
};
